import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type SearchAlertsJobDetailsModalXinglet = XingletInterface;

export const SearchAlertsJobDetailsModal = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-search-alerts-job-details-modal'
);
